import React, { Component } from "react";
import TransferCuentasTercerosService from "../../../../services/transferencias/TransferCuentasTercerosService";
import CuentaSocioTransferencia from "../../../generico/CuentaSocioTransferencia";
import CuentaExterna from "../../../generico/Transferencia/CuentaExterna/CuentaExterna";
import NumberFormat from "react-number-format";
import { splitImporte } from "../../../generico/utils/FormatoInput";
import { trackPromise } from "react-promise-tracker";
import Popup from "react-popup";
import $ from "jquery";
import {FontAwesomeIcon}  from "@fortawesome/react-fontawesome";
import {faArrowRight} from "@fortawesome/free-solid-svg-icons";
import authService from "../../../../services/login/auth.service";
import TransferInterbancaService from "../../../../services/transferencias/TransferInterbancaService";
import ConfigService from "../../../../services/configuracion/ConfigService";

export default class TransferCuentasTerceros extends Component {

  TIPO_DEBITO = "D";
  TIPO_CREDITO = "C";
  muestraEntrust = false;
  muestraOtp = false;
  constructor(props) {
    super(props);
    this.getCuentasOrigen = this.getCuentas.bind(this);
    this.state = this.getInitialState();
    this.button = React.createRef();
    this.monto = 0;
  }

  notifiPopup = (titulo, mensaje) =>
    Popup.register({
      title: titulo,
      content: mensaje,
      buttons: {
        right: [
          {
            text: "Aceptar",
            className: "success",
            action: function () {
              Popup.close();
            },
          },
        ],
      },
    });

  getInitialState = () => ({
    cuentasOrigen: [],
    cuentasDestino: [],
    cuentaDebito: "",
    cuentaCredito: "",
    monto: 0,
    itemsConfirm: [],
    cuentaOrigenSelected: [],
    itemSelected: { value: "-1", label: "--Seleccione--" },
    operConfirmada: false,
    nroOperacion: "",
  });

  resetState = () => {
    this.setState(this.getInitialState());
  };

  componentDidMount() {
    this.initData();
  }

  initData = () => {

    this.resetState();
    this.getCuentas(this.TIPO_DEBITO);
    this.button.current.disabled = true;
    this.entidadSelected = undefined;
    this.cuentaDestinoSelected = undefined;

  };

  async transferir(tipoPedido) {
    var _monto = splitImporte(this.monto);
    return await TransferCuentasTercerosService.transferir(
      tipoPedido,
      this.state.cuentaDebito,
      this.state.cuentaCredito,
      _monto
    );
  }

  async validarCuenta(cuentaDestino) {
    return await TransferCuentasTercerosService.validarCuenta(
      cuentaDestino
    );
  }

  selectCuentaTercero = (data) => {
    this.entidadSelected = data;
    if (data) this.setState({ ...this.state, cuentaCredito: data.nroCuenta });
    this.enableNext();
  };

  selectorValue = (dataFromChild, item) => {

    this.setState({
      ...this.state,
      cuentaOrigenSelected: dataFromChild,
      cuentaDebito: dataFromChild.ahorro,
      detalleCuenta: dataFromChild.ahorro + " - " + authService.getSocio().nombreCompleto.trim(),
      itemSelected: item,
    });
    //TODO verificar funcionamiento de habilitar boton continuar, segun lo seleccionado
    this.enableNext();
  };

  montoValue = (dataFromChild) => {
    this.monto = dataFromChild;
    this.setState({
      ...this.state,
      monto: dataFromChild,
    });
    this.enableNext();
  };

  enableNext() {

    console.log("enable next...");
    let itemSelected = this.state.itemSelected;
    if (
      itemSelected.value !== undefined &&
      itemSelected.value !== "-1" &&
      this.entidadSelected !== undefined && 
      (this.monto !== 0 && this.monto !== '0' )
    ) {
      console.log('habilitar');
      console.log({
        itemSelected : itemSelected.value,
        Entidad_Seleccionada : this.entidadSelected,
        MONTO_THIS : this.monto
      });
      // this.setState({disableSgte:false});
      this.button.current.disabled = false;
    } else {
      console.log('deshabilitar');
      console.log({
        itemSelected : itemSelected.value,
        Entidad_Seleccionada : this.entidadSelected,
        MONTO_THIS : this.monto
      });
      // this.setState({disableSgte:true});
      this.button.current.disabled = true;
    }

    //this.checkCuentaDestino();
  }

  disableBtnNext() {

    //console.log("disable next...");
    // return this.state.disableSgte;
    let itemSelected = this.state.itemSelected;
    if (
      itemSelected.value !== undefined &&
      itemSelected.value !== "-1" &&
      this.entidadSelected !== undefined &&
      this.state.monto !== 0
    // ){
    //   this.setState({disableSgte:false});
    // }else{
    //   this.setState({disableSgte : true});
    // }
    ) return false;

    return true;

    //this.checkCuentaDestino();
  }

  precondTrasnferir() {
    if (this.state.cuentaDebito === "") {
      Popup.queue(this.notifiPopup("Info", "Debe cargar la cuenta de Débito"));
      return false;
    }
    if (
      this.monto.toString().trim().length === 0 ||
      splitImporte(this.monto) === "0"
    ) {
      Popup.queue(this.notifiPopup("Info", "El monto debe ser mayor a 0"));
      return false;
    }
    if (this.state.cuentaCredito === "") {
      Popup.queue(this.notifiPopup("Info", "Debe cargar la cuenta de Crédito"));
      return false;
    }

    if (this.state.cuentaDebito === this.state.cuentaCredito) {
      Popup.queue(
        this.notifiPopup(
          "Info",
          "Las cuentas de Débito y crédito no pueden ser las mismas"
        )
      );

      return false;
    }

    return true;
  }

  pasarOTP(){
    
      TransferInterbancaService.generarOTP()
      .then(( response ) => {
        if(response.data.codigo === 0){
          const datogenerado = response.data.datos

          this.props.returnDataOTP(this.monto, datogenerado);
         this.props.nextStep();
         
        }
        else if(response.data.codigo === 2 || response.data.codigo === 1 ){
          Popup.queue(this.notifiPopup("Error", response.data.mensaje));
        }
        else{
          Popup.queue(this.notifiPopup("Error", "Ha ocurrido un error"));
        }
        })
        .catch(error => {
          console.log(error);
          
        })                   
    
    
    
  }


  verificarEntrustyOtp = () => {
    const tokenActivo = sessionStorage.getItem('tieneToken');

    tokenActivo === "S" && ConfigService.ocultarSegunNombre("entrust") === null ? 
    this.muestraEntrust = true : this.muestraEntrust = false;

    ConfigService.ocultarSegunNombre('otpSms') === null ?
    this.muestraOtp = true : this.muestraOtp = false;

  }

  handleContinuar = async (e) => {
    $('#btn-continue').attr('disabled', 'true');
    this.verificarEntrustyOtp();
    if (!this.precondTrasnferir()) {
      e.preventDefault();
    } else if( !this.muestraOtp && !this.muestraEntrust){
      Popup.queue(this.notifiPopup("Error", 'Para completar esta operación, por favor activa un token de seguridad en tu cuenta'));
    } else {
      var items = await this.loadDataConfirm();
      if (items.length > 0) {
        this.props.returnDataPaso1(
          this.state.cuentaDebito,
          this.state.cuentaCredito,
          //this.cuentaDestinoSelected,
          this.monto,
          items,
          this.state.detalleCuenta,
          this.state.cuentaOrigenSelected,
          this.muestraEntrust
        );
        if( !this.muestraEntrust ){
          this.pasarOTP();
        }
        this.nextStep.click(
          
        );
      }
      
    }
  };

  async verificar() {
    var jData = undefined;
    await this.validarCuenta(this.state.cuentaCredito).then((response) => {
      var data = JSON.stringify(response.data);
      jData = JSON.parse(data);
    });

    if (jData.codigo !== 0) {
      Popup.queue(this.notifiPopup("Info", jData.mensaje));
    }

    return jData;
  }

  async loadDataConfirm() {
    var jData = await this.verificar();
    var _itemsConfirm = [];
    if (jData.codigo === 0) {
      var datos = this.state.cuentaOrigenSelected;
      _itemsConfirm = [
        { concepto: "Cuenta Débito", valor: this.state.cuentaDebito },
        {
          concepto: "Importe del Débito en " + datos.moneda,
          valor: (
            <NumberFormat
              value={this.monto}
              displayType={"text"}
              decimalSeparator={","}
              thousandSeparator={"."}
            />
          ),
        },
        { concepto: "Cuenta Crédito", valor: this.state.cuentaCredito },
        {
          concepto: "Importe del Crédito en " + datos.moneda,
          valor: (
            <NumberFormat
              value={this.monto}
              displayType={"text"}
              decimalSeparator={","}
              thousandSeparator={"."}
            />
          ),
        },
        {
          concepto: "Titular de la Cuenta Destino",
          //valor: jData.datos,
          valor: jData.datos.nombreSocio,
        },
        {
          concepto: "Fecha de Operación",
          valor: (new Date()).toLocaleDateString('es-ES', { year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric' })
        },
      ];
    }
    return _itemsConfirm;
  }
  newTransferBtn = () => {
    this.initData();
  };

  confirmarBtn = () => {
    trackPromise(
      this.transferir("V").then((response) => {
        var data = JSON.stringify(response.data);
        var jData = JSON.parse(data);

        if (jData.codRespuesta === "000") {
          this.transferir("C")
            .then((response) => {
              var data = JSON.stringify(response.data);
              var jData = JSON.parse(data);
              if (jData.codRespuesta === "000") {
                this.setState({
                  operConfirmada: true,
                  nroOperacion: jData.numeroOperacion,
                });
              } else {
                Popup.queue(this.notifiPopup("Info", jData.codDescripcion));
              }
            })
            .catch(function (error) {
              console.log(error);
            });
        } else {
          Popup.queue(this.notifiPopup("Info", jData.codDescripcion));
        }
      })
    ).catch(function (error) {
      console.log(error);
    });
  };

  getCuentas(tipo) {
    trackPromise(
      TransferCuentasTercerosService.getCuentas(tipo).then((response) => {
        var data = JSON.stringify(response.data);

        var jsonData = JSON.parse(data);
        if (tipo === this.TIPO_DEBITO) {
          var cuentasDebitar = (jsonData.resultadoAH !== null ? jsonData.resultadoAH : []);
          if (jsonData.resultadoAF !== null) {
            for (let index = 0; index < jsonData.resultadoAF.length; index++) {
              cuentasDebitar.push(jsonData.resultadoAF[index]);
            }
          }
          this.setState({ cuentasOrigen: cuentasDebitar });
        } else if (tipo === this.TIPO_CREDITO) {
          this.setState({ cuentasDestino: jsonData.respuestaDetalles });
        }
      })
    );
  }

  render() {

    return (
      <div>
        <div className="row">
          <div className="steps clearfix">
            <ul role="tablist">
              <li role="tab" className="current">
                <span>
                  <div className="title">
                    <span className="title_text current">
                      Selección de Cuentas
                    </span>
                  </div>
                </span>
              </li>
              <li role="tab" className="disabled">
                <span>
                  <div className="title">
                    <span className="title_text">Código de Verificación</span>
                  </div>
                </span>
              </li>
              <li role="tab" className="disabled">
                <span>
                  <div className="title">
                    <span className="title_text">Datos de Verificación</span>
                  </div>
                </span>
              </li>

              <li role="tab" className="disabled last">
                <span>
                  <div className="title">
                    <span className="title_text">Confirmación</span>
                  </div>
                </span>
              </li>
            </ul>
          </div>
        </div>

        <section className="content">
          <div className="container">
            <div className="row justify-content-md-left">
              <div className="col-md-6">
                <div className="row">
                  <div className="col-md-12">

                    <CuentaSocioTransferencia
                      renderMonto="true"
                      selectorValue={this.selectorValue.bind(this)}
                      montoValue={this.montoValue.bind(this)}
                      operacion="DEBITO"
                      tipoCuenta="AHORRO_VISTA"
                      items={this.state.cuentasOrigen}
                      monto={this.monto}
                      itemSelected={this.state.itemSelected}
                    />
                  </div>
                </div>
                <div className="row">
                  {
                    /*
                    <div className="col-md-12">
                      <label className="input-label-bold">
                        Ingrese la Cuenta Destino (a acreditar) *
                      </label>
                      <input
                        onChange={this.handleChangeCuentaCredito}
                        value={this.state.cuentaCredito}
                        required
                        className="form-control input-box"
                      />
                    </div>
                    */
                  }
                </div>
              </div>
            </div>
            <br />
            <div className="row">
              <CuentaExterna intermediario="CU" selectCuentaExterna={this.selectCuentaTercero.bind(this)} />
            </div>
          </div>
        </section>

        <hr />

        <div className="row">
          <div className="col-lg-10 col-md-9">
              <label
                className="input-label-bold-obligatorio">
                (*) Campos Obligatorios
                <br />
              </label>
          </div>
          <div className="col-lg-2 col-md-3">
              <button
                id="btn-continue"
                // ref={(button) => (this.continuar = button)}
                ref={ this.button }
                // disabled={this.state.continuar.disabled}
                // disabled={this.disableBtnNext()}
                className="btn btn-cu-primary"
                onClick={this.handleContinuar}
              >
               Continuar <FontAwesomeIcon icon={faArrowRight} />
              </button>
          </div>
          <button
            hidden
            ref={(a) => (this.nextStep = a)}
            className="btn btn-cu-primary"
            onClick={this.props.nextStep}
          ></button>
        </div>
      </div>
    );
  }
}
